import { useRef } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import type { IContext } from './columns'
import type { AgGridReact } from 'ag-grid-react'
import type { ReactElement } from 'react'

import columns from './columns'

import ContentLayout from '~/components/ContentLayout'
import Header from '~/components/Header/Classic'
import Layout from '~/components/Layouts/Layout'
import Section from '~/components/Section'
import TableWrapper from '~/components/Tables/TableWrapper'
import UserCard from '~/components/UserCard'
import ViewTitle from '~/components/ViewTitle'
import useDocumentTitle from '~/hooks/useDocumentTitle'
import { useAppSummary } from '~/providers/AppSummary'
import { useSearchProjects } from '~/queries/reports'
import { transformByDeviceType } from '~/utils/application'

import './styles.scss'

const ProfileProjects = (): ReactElement => {
  /** Local state */

  const navigate = useNavigate()

  const { profileId } = useParams()

  const { appDetails, appKey, deviceType } = useAppSummary()

  const gridRef = useRef<AgGridReact>(null)

  const tableRef = useRef<HTMLDivElement>(null)

  /** Queries & Mutations */

  const { data: projects, isLoading: isProjectsLoading } = useSearchProjects({
    appKey,
    deviceType,
    profileId,
  })

  /** Effects */

  useDocumentTitle('Profiles - Projects')

  /** Handlers */

  const handleRedirect = (path: string) => navigate(path)

  /** Render */

  const { profile_picture_id, username } = projects?.length ? projects[0] : { profile_picture_id: '', username: '' }

  const context: IContext = { handleRedirect }

  const appSelectorApp = appDetails ? transformByDeviceType(appDetails, deviceType) : undefined

  const isSwitchDisabled = !appDetails?.android || !appDetails?.ios

  return (
    <>
      <Header apps={appSelectorApp ? [appSelectorApp] : []} isSwitchDisabled={isSwitchDisabled} />
      <Layout className="projects-view" withPadding>
        <ViewTitle className="layout-view-title">
          <div>Profile Projects</div>
          <UserCard name={username} picture={profile_picture_id} />
        </ViewTitle>
        <ContentLayout loading={isProjectsLoading}>
          <Section>
            <TableWrapper
              className="projects-table with-min-height"
              columnDefs={columns}
              context={context}
              entriesName="profile-projects"
              ref={gridRef}
              rowData={projects}
              tableRef={tableRef}
              withSearchBar
            />
          </Section>
        </ContentLayout>
      </Layout>
    </>
  )
}
export default ProfileProjects
